import React, { useState, useRef, useEffect } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Button,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import OutsideClickHandler from 'react-outside-click-handler';


const OverviewSidebar = ({closeSidebar, sidebarValue}) => {
  const [selectedInsight, setSelectedInsight] = useState('revenue');
  
  // Update selectedInsight when sidebarValue changes
  useEffect(() => {
    if (sidebarValue) {
      setSelectedInsight(sidebarValue);
    }
  }, [sidebarValue]);
  const insightOptions = [
    // Existing insights
    { value: 'Revenue', label: 'Revenue' },
    { value: 'Lease Cost', label: 'Lease Cost' },
    { value: 'Employee Cost', label: 'Employee Cost' },
    { value: 'Est. Foot Traffic', label: 'Est. Foot Traffic' },
    { value: 'New Members', label: 'New Members' },
    { value: 'Total Members', label: 'Total Members' },
    { value: 'Average Transaction Value', label: 'Average Transaction Value' },
    { value: 'Average Number of Visits', label: 'Average Number of Visits' },
  
    // Additional insights
    { value: 'profit_margin', label: 'Profit Margin' },
    { value: 'cost_per_visit', label: 'Cost per Visit' },
    { value: 'marketing_spend', label: 'Marketing Spend per Location' },
    { value: 'roas', label: 'Return on Ad Spend (ROAS)' },
    { value: 'revenue_per_sqft', label: 'Revenue per Sq Ft' },
    { value: 'conversion_rate', label: 'Passerby Conversion Rate' },
    { value: 'top_customer_segment', label: 'Top Customer Segment' },
    { value: 'visit_purpose', label: 'Dominant Visit Purpose' },
    { value: 'churn_rate', label: 'Loyalty Churn Rate' },
    { value: 'campaign_uplift', label: 'Campaign Uplift' },
    { value: 'catchment_population', label: 'Catchment Area Population' },
    { value: 'psychographic_score', label: 'Psychographic Match Score' },
    { value: 'underperforming_locations', label: 'Underperforming Locations Count' },
    { value: 'visitor_ratio', label: 'New vs Returning Visitor Ratio' },
  
    // Generic insights from your example
    { value: 'conversion', label: 'Conversion Rates' },
    { value: 'traffic', label: 'Traffic Sources' },
    { value: 'retention', label: 'Customer Retention' },
    { value: 'performance', label: 'Performance Metrics' },
    { value: 'churn', label: 'Churn Analysis' }
  ];
  

  const handleInsightChange = (event) => {
    setSelectedInsight(event.target.value);
    // Add any additional logic here to update widgets
    console.log('Selected insight:', event.target.value);
  };

  return (
    <div className={`${sidebarValue ? 'task-search-background': '' }`}>
      <div className={sidebarValue ? 'overview-sidebar-total' : 'overview-sidebar-total sidebar-total-hide'}>
      <OutsideClickHandler onOutsideClick={closeSidebar} >
        <div className='overview-sidebar-scroll ml-10 mr-10 mt-10'>
            <Box>
                <IconButton
                    onClick={closeSidebar}
                    size="small"
                    sx={{
                    color: '#666',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    }}
                >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          <h2 className='mt-20 mb-20 font-weight600 data-component'>                Change Insight for Selected Widget</h2>
          
          <Box sx={{ mt: 2 }}>
            <FormControl component="fieldset">
              <RadioGroup
                value={selectedInsight}
                onChange={handleInsightChange}
                name="insight-radio-group"
              >
                {insightOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    disabled={true}
                    control={
                      <Radio 
                        size="small"
                        disabled={true}
                        sx={{
                          color: '#666',
                          '&.Mui-checked': {
                            color: '#1976d2',
                          },
                          '&.Mui-disabled': {
                            color: '#ccc',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontSize: '0.875rem',
                          color: '#999'
                        }}
                      >
                        {option.label}
                      </Typography>
                    }
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: '0.875rem',
                      },
                      mb: 0.5,
                      '&.Mui-disabled': {
                        '& .MuiFormControlLabel-label': {
                          color: '#999',
                        },
                      },
                    }}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ mt: 3, mb: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={()=> {}}
              sx={{
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 500,
                py: 1.5,
              }}
            >
              Save Changes
            </Button>
          </Box>
        </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default OverviewSidebar;